import axios from "axios";
import { getApiUrl } from "../../utils/urls";
import cookiesProvider from "../cookies-provider";
import { storageProvider } from "../storage-provider";

const apiUrl = getApiUrl();

const publicRoutes = ['esr', 'password-reset', 'lti', 'documentacao-api', 'sso']

const authProvider = {

  getInstitutionsAndProducts: async ({ username, password }) => {
    return await axios.post(`${apiUrl}/auth/getInstitutionsAndProducts`, { email: username, password })
  },

  getUserContexts: async ({ username, password }) => {
    return await axios.post(`${apiUrl}/auth/getUserContexts`, { email: username, password })
  },

  login: async ({ username, password, institutionId, productId }) => {
    return await axios.post(`${apiUrl}/auth/signin`, { email: username, password, institutionId, productId })
      .then(
        (response) => {
          const { id, token } = response.data;
          cookiesProvider.setUser(id);
          cookiesProvider.setToken(token);
          storageProvider.setCurrentUser(response.data)
          return Promise.resolve(response.data);
        }
      ).catch(
        (error) => {
          return Promise.reject(error)
        }
      );
  },


  loginContext: async ({ username, password, context, product, contexts }) => {
    return await axios.post(`${apiUrl}/auth/signinContext`, { email: username, password, contextId: context, productId: product })
      .then((response) => {
        const { token, product, context } = response.data;
        cookiesProvider.setUser(context.user.id);
        cookiesProvider.setToken(token);
        storageProvider.setCurrentContext({ user_context: context, product, contexts })
        return Promise.resolve(response.data);
      }).catch((error) => { return Promise.reject(error) });
  },

  switchContext: async (context, contexts, product) => {
    const token = cookiesProvider.getToken();
    return await axios.post(`${apiUrl}/auth/switchContext`, { id: context.id }, { headers: { Authorization: `Bearer ${token}` } })
      .then((response) => {
        const { token, context } = response.data;
        cookiesProvider.setUser(context.user.id);
        cookiesProvider.setToken(token);
        storageProvider.setCurrentContext({ user_context: context, product, contexts })
        return Promise.resolve(response.data);
      }).catch((error) => { return Promise.reject(error) });
  },

  ltiLogin: async ({ username }) => {
    return await axios.post(`${apiUrl}/auth/ltiSignin`, { email: username })
      .then(
        (response) => {
          const { id, token } = response.data;
          cookiesProvider.setUser(id);
          cookiesProvider.setToken(token)
          return Promise.resolve(response.data);
        }
      ).catch(
        (error) => {
          return Promise.reject(error)
        }
      );
  },


  ssoFetchToken: async (institution, token) => {
    return await axios.post(`${apiUrl}/federated/${institution}`, { student_token: token })
  },

  ssoAuthenticate: async (ssoToken) => {
    return await axios.post(`${apiUrl}/auth/signinFederated`, { token: ssoToken })
      .then((response) => {
        const { token, product, context } = response.data;
        cookiesProvider.setUser(context.user.id);
        cookiesProvider.setToken(token);
        storageProvider.setCurrentContext({ user_context: context, product })
        return Promise.resolve(response.data);
      })
      .catch((error) => { return Promise.reject(error) });
  },

  checkError: ({ status }) => {
    if (status === 401 || status === 403) {
      cookiesProvider.removeUser();
      cookiesProvider.removeToken();
      storageProvider.setCurrentUser(undefined)
      return Promise.reject();
    }
    return Promise.resolve();
  },

  checkAuth: () => {

    const url = window.location.href.split('/')
    if (publicRoutes.includes(url[4])) {
      return Promise.resolve();
    }
    return cookiesProvider.getUser() ? Promise.resolve() : Promise.reject({ message: false });
  },

  logout: () => {
    cookiesProvider.removeToken();
    cookiesProvider.removeUser();
    storageProvider.removeCurrentContext()
    return Promise.resolve();
  },

  getIdentity: () => {
    const url = window.location.href.split('/')
    if (publicRoutes.includes(url[4])) {
      return Promise.resolve(
        { data: { id: 0, fullName: 'guest' } }
      );
    } else {
      const appcontext = storageProvider.getCurrentContext()
      return appcontext.context.user
    }
  },

  // authorization
  getPermissions: (params) => {
    const url = window.location.href.split('/')
    if (publicRoutes.includes(url[4])) {
      return Promise.resolve('guest');
    }
    const appcontext = storageProvider.getCurrentContext()
    return Promise.resolve(appcontext.user_context.profile.permissions)
  },
}

export default authProvider;